import { scene } from './scene/scene';
import { axis } from './axis';
import { camera } from './camera';
import { legend } from './legend';
import { timebars } from './timebar';
import { toolbar } from './toolbar';
import { labels } from './labels';
import { layout } from './layout';
import { encodings } from './encodings';
import { inspector } from './inspector';
import { selection } from './selection';
import { expressions } from './expressions';
import { expander } from './expander';
import { collections } from './collections';
import { kepler } from './kepler';
import { chat } from './chat';
import { $atom, ref as $ref } from '@graphistry/falcor-json-graph';

const logger = require('@graphistry/logger')(module);

export function opt(options, prop, t, def) {
    try {
        const transform = t instanceof Array ? ((v) => v) : t;
        const out =  prop in options ? transform(options[prop]) : def;
        if (t === Number) {
            if (Number.isNaN(out)) {
                return def;
            }
        }
        if (t === Boolean && prop in options) {
            if (options[prop] === 'false') {
                return false;
            }
        }
        if (t instanceof Array) {
            return t.find(v => v === out) ? out : def;
        }
        return out;
    } catch (e) {
        return def;
    }
}

export function views(workbookId, viewId = workbookId) {
    
    logger.trace('@views', { workbookId, viewId });

    const view = `workbooksById['${workbookId}'].viewsById['${viewId}']`;
    return {
        views: {
            length: 1,
            current: $ref(`${view}`, { $expires: 1 }),
            0: $ref(`${view}`, { $expires: 1 })
        },
        viewsById: {}
    };
}

//WARNING: encodings manager sets up a weakmap against view object ref, not id
export function view(workbookId, viewId = workbookId, options) {

    logger.trace('@view()', { workbookId, viewId });

    const o = options.vizClientParams || {};

    const flags = {};
    for (let key in options) {
        if (key.startsWith('flag_')) {
            flags[key] = !!options[key];
        }
    }
    logger.trace({flags, options}, 'view flags');

    const view = `workbooksById['${workbookId}'].viewsById['${viewId}']`;
    return {
        id: viewId,
        entitlements: $atom({}),
        flags: $atom(flags),
        dataset: $ref(`workbooksById['${workbookId}'].datasets['0']`),
        title: '',
        columns: [],
        absolutePath: view,
        pruneOrphans: opt(o, 'pruneOrphans', Boolean, false),
        panels: {
            // left: undefined,
            right: $ref(`${view}.histograms`)
            // bottom: undefined
        },
        ...camera(view),
        ...scene(view, 'default', options),
        ...labels(view, options),
        ...axis(view),
        ...layout(view, options),
        ...legend(view),
        ...timebars(view),
        ...encodings(view, options),
        ...inspector(view),
        ...selection(view),
        ...expressions(view, options),
        ...toolbar(workbookId, viewId),
        ...expander(view),
        ...collections(view, options),
        ...kepler(view, options),
        ...chat(view, options)
    };
}
